import React from 'react'

import _modules from '../../../../_modules'
const ProductUnits = React.lazy(() => import('./views/productUnits/ProductUnits'))
const ProductUnitsDetail = React.lazy(() => import('./views/productUnits/ProductUnitsDetail'))
const ProductLines = React.lazy(() => import('./views/productLines/ProductLines'))
const ProductLinesDetail = React.lazy(() => import('./views/productLines/ProductLinesDetail'))
const Products = React.lazy(() => import('./views/products/Products'))
const ProductsDetail = React.lazy(() => import('./views/products/ProductsDetail'))
const MaterialCategories = React.lazy(() => import('./views/materialCategories/MaterialCategories'))
const MaterialCategoriesDetail = React.lazy(() =>
  import('./views/materialCategories/MaterialCategoriesDetail'),
)

const _routes = []

if (_modules.products) {
  _routes.push(
    ...[
      {
        path: '/products/product-units/:id',
        name: 'Product Units Detail',
        component: ProductUnitsDetail,
      },
      { path: '/products/product-units', name: 'Product Units', component: ProductUnits },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/products/product-lines/:id',
        name: 'Product Lines Detail',
        component: ProductLinesDetail,
      },
      { path: '/products/product-lines', name: 'Product Lines', component: ProductLines },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/products/material-categories/:id',
        name: 'Material Categories Detail',
        component: MaterialCategoriesDetail,
      },
      {
        path: '/products/material-categories',
        name: 'Material Categories',
        component: MaterialCategories,
      },
    ],
  )
  _routes.push(
    ...[
      { path: '/products/:id', name: 'Products Detail', component: ProductsDetail },
      { path: '/products', name: 'Products', component: Products },
    ],
  )
}

export default _routes
